(function () {
  const renderBullets = (swiper, current, total) => {
    let out = "";
    for (let i = 1; i < total + 1; i++) {
      const active = i === current ? " swiper-pagination-bullet-active" : "";
      out += `<span class="swiper-pagination-bullet${active}" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`;
    }
    return out;
  };

  const initSlider = (root) => {
    const container = root.querySelector("[data-card-slider-swiper]");
    if (!container || typeof Swiper === "undefined") return;

    if (container.swiperInstance) {
      container.swiperInstance.destroy(true, true);
      container.swiperInstance = null;
    }

    const slides = container.querySelectorAll(".swiper-slide");
    if (!slides.length) return;

    const styles = getComputedStyle(root);
    const columns = Number(root.dataset.columns) || 4;
    const columnsMobile = Number(root.dataset.columnsMobile) || 1;
    const gap = parseInt(styles.getPropertyValue("--cs-gap"), 10) || 24;
    const gapMobile = parseInt(styles.getPropertyValue("--cs-gap-mobile"), 10) || 12;

    // Looping with fewer slides than are visible produces a broken track.
    const loop = root.dataset.loop === "true" && slides.length > columns;

    const options = {
      loop: loop,
      speed: 600,
      watchOverflow: true,
      slidesPerView: columnsMobile === 1 ? 1.15 : 2,
      spaceBetween: gapMobile,
      breakpoints: {
        750: {
          slidesPerView: Math.min(2, columns),
          slidesPerGroup: 1,
          spaceBetween: gap,
        },
        990: {
          slidesPerView: Math.min(3, columns),
          slidesPerGroup: 1,
          spaceBetween: gap,
        },
        1200: {
          slidesPerView: columns,
          slidesPerGroup: 1,
          spaceBetween: gap,
        },
      },
    };

    const prev = root.querySelector("[data-card-slider-prev]");
    const next = root.querySelector("[data-card-slider-next]");
    if (prev && next) {
      options.navigation = {
        prevEl: prev,
        nextEl: next,
        disabledClass: "swiper-button-disabled",
        lockClass: "swiper-button-lock",
      };
    }

    const pagination = root.querySelector("[data-card-slider-pagination]");
    if (pagination) {
      options.pagination = {
        el: pagination,
        clickable: true,
        type: "custom",
        renderCustom: renderBullets,
      };
    }

    if (root.dataset.autoplay === "true") {
      options.autoplay = {
        delay: Number(root.dataset.delay) || 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    container.swiperInstance = new Swiper(container, options);
  };

  const destroySlider = (root) => {
    const container = root.querySelector("[data-card-slider-swiper]");
    if (container && container.swiperInstance) {
      container.swiperInstance.destroy(true, true);
      container.swiperInstance = null;
    }
  };

  const initSection = (section) => {
    if (!section || !section.querySelectorAll) return;
    section.querySelectorAll("[data-card-slider]").forEach(initSlider);
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", (event) => {
    initSection(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    event.target.querySelectorAll("[data-card-slider]").forEach(destroySlider);
  });

  document.addEventListener("shopify:block:select", (event) => {
    const root = event.target.closest("[data-card-slider]");
    if (!root) return;
    const container = root.querySelector("[data-card-slider-swiper]");
    if (!container || !container.swiperInstance) return;

    const index = Array.prototype.indexOf.call(
      container.querySelectorAll(".swiper-slide"),
      event.target
    );
    if (index > -1) container.swiperInstance.slideTo(index);
  });
})();